<template>
  <section class="grid-flex column">
    <!-- filters -->
    <div class="flex-1 w100">
      <div class="flex row middle">
        <div class="flex-2 w100">
          <div class="flex end filters-group-holder row">
            <div class="filter-item flex-1 w100">
              <label>Agrupar Por</label>
              <select class="input" v-model="filters.data.groupBy">
                <option v-for="(c, index) in filters.list.listGroupBy" :key="index" :value="c.value" :selected="c.value === filters.data.groupBy">
                  {{ c.label }}
                </option>
              </select>
            </div>

            <ltk-date-picker
              label="Filtro de data"
              v-model="filters.data.date"
              :loading="loading"
            ></ltk-date-picker>
          </div>
        </div>
      </div>
    </div>
    <div class="box flex-1 w100 margin-top-l">
      <div class="box-content">
        <h3>Visitas por dia:</h3>
        <div v-if="loading">
          <content-loading>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
          </content-loading>
        </div>
        <line-chart
          v-if="!loading &&
            chartLINE.data.datasets &&
              chartLINE.data.datasets.length > 0
          "
          class="margin-top-l"
          :height="140"
          :chartData="chartLINE.data"
          :options="chartLINE.options"
          :limit="30"
          color="green"
        ></line-chart>
      </div>
    </div>

    <section class="flex-1 w100 flex middle column margin-top-l">
      <div class="box flex-1 w100">
        <div class="box-content list-items">
          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
          <ul v-else>
            <li>
              <div class="flex w100">
                <div class="flex-2"><b>Páginas</b></div>
                <div class="flex-1 txt-center"><b>Visitas</b></div>
              </div>
            </li>
            <li v-for="(p, k) in pages" :key="k" class="item">
              <div class="flex w100" @click="p.open = !p.open">
                <div class="flex-2 flex middle">
                  <div v-if="report[p.id] && report[p.id]['origens'][filters.data.groupBy]">
                    <i v-if="!p.open" class="fas fa-angle-right"></i>
                    <i v-else class="fas fa-angle-down"></i>
                  </div>
                  <div style="margin-left: 8px">
                    <a :href="fixUrl(p.url)" target="_blank">
                      <i class="fas fa-link"></i> {{ p.url | protect }}
                    </a>
                  </div>
                </div>
                <div class="flex-1 txt-center">
                  {{ p.pvs | number }}
                </div>
              </div>
              <div v-if="p.open" class="flex w100 flex-1 padding-left margin-top-m">
                <ul v-if="report[p.id] && report[p.id]['origens'][filters.data.groupBy]" class="flex w100 column" style="margin-left: 8px">
                  
                  <li v-for="(v, k) in report[p.id]['origens'][filters.data.groupBy]" :key="k" class="flex w100">
                    <div class="flex w100">
                      <div class="flex-2 flex column">
                        <div class="max-utm">
                          {{ v.name  | protect }}
                        </div>
                        <div><small>{{ filters.data.groupBy }}</small></div>
                      </div>
                      <div class="flex-1 txt-center">
                        {{ v.pvs | number }}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>

    </section>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";

import ltkDatePicker from "@/components/datepicker/LtkDatePicker";
import lineChart from "@/components/charts/lineChart";

import {
  getPagesReport,
} from "@/services/page";

export default {
  name: "report-pages",
  components: {
    ltkDatePicker,
    lineChart
  },
  data() {
    return {
      loading: false,
      filters: {
        data: {
          date: [
            moment()
              .add(-30, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          search: "",
          groupBy: 'utm_campaign',
        },
        list: {
          listGroupBy: [
            { value: 'utm_campaign', label: 'utm_campaign' },
            { value: 'utm_source', label: 'utm_source' },
            { value: 'utm_medium', label: 'utm_medium' },
            { value: 'utm_content', label: 'utm_content' },
            { value: 'utm_term', label: 'utm_term' },
            { value: 'sck', label: 'sck' },
            { value: 'src', label: 'src' },
          ]
        },
      },
      
      stats: {},
      pages: {},
      report: {},
      chartLINE: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
    };
  },
  mounted() {
    this.getPagesReport();
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.getPagesReport()
      },
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  methods: {
    fixUrl(url) {
      if (!url) {
        return 
      }

      if (url.includes("http")) {
        return url
      }

      return `http://${url}`
    },
    getPagesReport() {
      if (this.loading) {
        return
      }

      this.loading = true;
      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
      };

      getPagesReport(params)
        .then((result) => {
          this.pages = result.pages.map(p => { return {...p, open: false} })
          this.stats = result.stats
          this.report = result.report

          // graph sale
          this.chartLINE.data.labels = result.graph.labels;
          var auxDataset = [];
          result.graph.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label}`,
              data: d.data,
            });
          });
          this.chartLINE.data.datasets = [auxDataset[0]];
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};

</script>

<style lang="scss" scoped>

.box + .box {
  margin-top: 8px;
  margin-left: 0px !important;
}

.name {
  max-width: 400px;
  width: 400px;
  min-width: 400px;
  padding-right: 16px;
}
.list-items {
  ul {
    list-style: none;

    li {
      padding: 16px 8px;
      border-bottom: 1px solid #dfdfdf;
      cursor: pointer;
      i {
        color: var(--primary);
        font-size: 14px;
      }
    }
  }
  .padding-left {
    padding-left: 8px
  }
  .max-utm {
    max-width: 800px;
    overflow: hidden;
  }
}

</style>
